import React, { useEffect } from 'react';
                                                                                                                                                                                                                                                                                    import './programassociales.css';
                                                                                                                                                                                                                                                                                    import { programassociales } from '../../json/programassociales';

const Madrestrabajadoras = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Bienestar de Madres Trabajadoras"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                El Programa de Bienestar de Madres Trabajadoras se sustenta en las políticas públicas del Gobierno del Estado de Hidalgo orientadas a promover la igualdad sustantiva, fortalecer la autonomía económica de las mujeres y reducir las brechas derivadas del trabajo de cuidados no remunerado, en congruencia con los principios de derechos humanos y con los instrumentos de planeación vigentes, como el Plan Estatal de Desarrollo 2022–2028, el Programa Sectorial de Desarrollo para el Bienestar e Inclusión Social 2023–2028 y la Agenda 2030. En este marco, el Estado impulsa acciones focalizadas que favorecen la permanencia laboral y educativa de madres trabajadoras y estudiantes.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar las condiciones de acceso y permanencia en el mercado laboral o en los estudios de las madres trabajadoras o madres estudiantes, que no cuenten con la prestación de cuidado infantil, conforme al Plan Estatal de Desarrollo 2022-2028, dando prioridad a la población que se encuentra en situación de marginación, pobreza, rezago social o con población indígena, mediante la entrega de apoyos económicos en las 12 regiones del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Madres trabajadoras o madres estudiantes, que tengan una hija o hijo de 0 a 5 años y 11 meses de edad, sin acceso a los servicios de cuidado y atención infantil, que perciban un ingreso comprobable menor a los $8,500.00 (Ocho mil quinientos pesos 00/100) de manera mensual, dando preferencia a las personas que habiten en las localidades de marginación, pobreza, rezago social o con población indígena en el Estado de Hidalgo, con base en los índices de medición aplicables.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                La cobertura del programa abarca las 12 regiones del Estado de Hidalgo, conforme a la suficiencia presupuestal y financiera.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Ejercicio fiscal 2026
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                <ul>
                <li><b>Subsecretaría de Inclusión y Desarrollo</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                </ul>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Mtro. Juan Roberto Lazcano Trejo
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 717 6000 Ext. 8948
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Horario de atención</h5>
                <p>
                Lunes a Viernes de 9:30 – 17:00 hrs
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Bienestar_de_Madres_Trabajadoras_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2026</a>
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatoria</h5>
                <ul>
                <li>
                <a
                href='/Convocatorias/BMT'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Marzo 2026</a>
                </li>
                  </ul>

                  
                
                 <p></p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Consulta de folios beneficiados</h5>
                <ul>
                  <li>
                <a
                href='https://amigosdelatransformacion.com.mx/ms.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://amigosdelatransformacion.com.mx/msoct.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Estadisticas</h5>
                <ul>
                  <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/estadisticas/3erT/Est_BMS_2024_3erT.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Tercer Trimestre</a>
                </li>
                </ul>

                
                 <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Lineamientos del Comité Técnico Dictaminador</h5>
                <ul>
                  <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/lineamientos/2023/Lineamientos_CTD_MS_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >2023</a>
                </li>
                </ul>

               
                </p>
                
              </div>
            </div>
            
          </div>
        </div>

      </div>    
    </div>
  );
};

export default Madrestrabajadoras;